const extractSkuNumbersFromString = (
  skuString?: string,
): string[] => {
  if (skuString) {
    const skuArray = skuString
      .split(/[;]/)
      .map(el => el.split(':')[0])
      .filter((v) => !!v);

    return skuArray;
  }

  return [];
};

export {
  extractSkuNumbersFromString,
};
